import { Component, ElementRef } from "@angular/core";
import { IHeaderParams } from "ag-grid-community";
import { IHeaderAngularComp } from "ag-grid-angular/main";

interface MyParams extends IHeaderParams {
    onClick: Function,
    icon: string
}

@Component({
    selector: 'add-button',
    template: '<button (click)="onClick()" mat-button type="button" style="line-height: 24px;"><mat-icon class="iconsize-20 mat-icon material-icons">{{icon}}</mat-icon></button>'
})
export class HeaderButtonComponent implements IHeaderAngularComp {
    public params: MyParams;
    private elementRef: ElementRef;
    public icon: string;

    constructor(elementRef: ElementRef) {
        this.elementRef = elementRef;
    }

    agInit(params: any): void {
        this.params = params;
        this.icon = params.icon;
    }

    ngOnDestroy() {
        console.log(`Destroying HeaderComponent`);
    }

    onClick() {
        if (this.params.onClick)
            this.params.onClick(this.params);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/grid/buttons/header-button.component.ts